import styled from '@emotion/styled';
import { GridConfig } from './GridSizes';
import MediaQueries from './MediaQueries';

const Row = styled.div(
  {
    display: 'flex',
    flexWrap: 'wrap',
  },
  () => ({
    [MediaQueries.sm]: {
      marginRight: -(GridConfig.sm.gutter / 2),
      marginLeft: -(GridConfig.sm.gutter / 2),
    },
    [MediaQueries.md]: {
      marginRight: -(GridConfig.md.gutter / 2),
      marginLeft: -(GridConfig.md.gutter / 2),
    },
    [MediaQueries.lg]: {
      marginRight: -(GridConfig.lg.gutter / 2),
      marginLeft: -(GridConfig.lg.gutter / 2),
    },
    [MediaQueries.xl]: {
      marginRight: -(GridConfig.xl.gutter / 2),
      marginLeft: -(GridConfig.xl.gutter / 2),
    },
  }),
);

export default Row;
